import { type FC } from 'react';

import { useSeriaPlusByLocation } from 'shared/settings/seriaPlusScheme';

import { SeriaPlus } from './SeriaPlus';

export const SeriaPlusContainer: FC = () => {
  const seriaPlusByLocation = useSeriaPlusByLocation();

  return seriaPlusByLocation ? <SeriaPlus scheme={seriaPlusByLocation} /> : null;
};
